import { MouseEvent, RefObject } from "react"

import { TableHeaderCellHideShow } from "./TableHeaderCellHideShow"
import { classNames } from "../../../../lib/classNames"
import { TableCell, TableCellProps } from "../TableCell/TableCell"

export const TABLE_HEADER_CELL_STYLES = "color-default text-body-strong"

export interface TableHeaderCellProps
  extends Omit<Extract<TableCellProps, { as: "th" }>, "as"> {
  onStartResize?: (e: MouseEvent<HTMLDivElement>) => void
  onToggleColumnHideShow?: () => void
  ref?: RefObject<HTMLTableCellElement>
}

export function TableHeaderCell({
  className,
  children,
  onStartResize,
  onToggleColumnHideShow,
  hideColumnBorders,
  ref,
  ...otherProps
}: TableHeaderCellProps) {
  return (
    <TableCell
      ref={ref}
      as="th"
      hideColumnBorders={hideColumnBorders}
      className={classNames(TABLE_HEADER_CELL_STYLES, "relative", className)}
      {...otherProps}
    >
      {onToggleColumnHideShow ? (
        <TableHeaderCellHideShow
          onToggleColumnHideShow={onToggleColumnHideShow}
        >
          {children}
        </TableHeaderCellHideShow>
      ) : (
        children
      )}
      {onStartResize && (
        <div
          className="hover:bg-v2-background-active-hover active:bg-v2-border-active absolute inset-y-0 right-0 w-1.5 cursor-col-resize"
          onMouseDown={onStartResize}
        />
      )}
    </TableCell>
  )
}
